import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef
} from '@angular/core';

import { Model } from 'src/app/model/model';
import { KeycloakService } from 'keycloak-angular';
import { PopUpManager, WizEvent, WizEventManager, WizPopUp, WizRoot, WizTranslationManager } from '@wizeoo/akm-component-lib';
import { ALK_EVENT_TYPE, AlkEvent, BaseView, LogoutCommand, ViewData } from '@wizeoo/akm-common-lib';
import { UserPop } from '../user/user.pop';
import { APP_EVENT_TYPE } from 'src/app/model/enums';
import { RouteEngine } from 'src/app/manager/routing/route.engine';
import { MenuPopUp } from './menu.pop';

@Component({
  selector: 'menu-bar',
  templateUrl: './menu.bar.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationBar implements AfterViewInit {

  // fiche user
  public userPop: WizPopUp = null; // popUp d'affichage du panel user


  // le breadcrumb
  public breadcrumb: string = '';

  deferredPrompt: any;
  showInstallButton = false;
  showIosInstallInstructions = false;


  constructor(public elRef: ElementRef, private cdref: ChangeDetectorRef, private security: KeycloakService) {
  }



  
  ngAfterViewInit(): void {

    window.addEventListener('beforeinstallprompt', (e) => {
        console.log('beforeinstallprompt', e);
        // Empêche l'affichage automatique de la bannière
        e.preventDefault();
        this.deferredPrompt = e;
        this.showInstallButton = true; // Affiche le bouton dans le template
    });
    WizEventManager.addListener(this, WizRoot.root(), APP_EVENT_TYPE.BREAD, this.feedBread);
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.UPDATE_MODEL, this.updateModel); // écouteur global change pour modelUpdate
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.WIDGET_STATE, this.feedViewState);
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.VERBOSE, this.feedVerbose);
  }

  /**
   * alimentation du breadcrumb
   * @param bread 
   */
  public feedBread(e:AlkEvent): void {
    this.breadcrumb = e.data || null;
     this.cdref.markForCheck();
  }

  /**
   * modif du modèle, refresh des boutons save / cancel
   * @param e 
   */
  private updateModel(e: WizEvent): void {
    this.cdref.markForCheck();
  }

  /** desactivation des boutons save et cancel sur updateModel */
  public disableButtons(): boolean {
    return !ViewData.wizUpdateModel;
  }

  /**
   * masque les boutons de saisie sur la vue de fallback et d'init
   */
  public actionView():boolean {
    const currV: BaseView = Model.getInstance().navigationEngine.getCurrentView();
    if(!currV) {
      return false;
    }

    if(currV.code === RouteEngine.INIT_VIEW) {
      return false;
    }
    else if(currV.code === RouteEngine.FALLBACK_VIEW) {
      return false;
    }
    return true;
  }

    /** sur alimentation du user, affichage de message de bienvenue */
  public get userLabel(): string {
    if (Model.getInstance().connectedUser) {
      return  WizTranslationManager.getInstance().translateKey('$.account.hello.$', [
        Model.getInstance().connectedUser.fullName,
      ]);
    } else {
      return ' ';
    }
  }

  /** déclenche une action */
  public do(action: string): void {
    switch (action) {   
      case "menu":  
        // demande de redimensionnement du panel
        WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(APP_EVENT_TYPE.SWAP_PANEL, null));
        break;      
      case "profile":
        this.showUserPop();
        break;
      case "help":  

        break;
      case "disconnect":  
        
      // if ((window as any).matchMedia('(display-mode: standalone)').matches) {
      //   window.close();
      // } else {
      //   console.warn('Impossible de fermer : pas en mode standalone');
      // }
      
      // Logout locale
        this.security.logout();
        // Logout serveur pour tuer la session spring security
        new LogoutCommand().execute();
        break;
      case "merge":  
         WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(APP_EVENT_TYPE.MAIN_SAVE, null));
         break;      
       case "cancel":
         WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(APP_EVENT_TYPE.MAIN_CANCEL, null));
         break;
    }
  }

  private showUserPop(): void {
        if (PopUpManager.exist(this.userPop)) {
      // suppression de l'instance existante
      this.userPop.hide();
      return;
    }

    // construction unique de l'instance
    this.userPop = new WizPopUp(UserPop, false, false, null, UserPop.WIDTH, UserPop.HEIGHT, null, null, {
      right: '20px',
      top: '40px',
    });
    
    this.userPop.show();
  }

  /** jump vers une vue */
  public go(view: string): void {
    Model.getInstance().navigationEngine.navigate(view);
  }

  public burgerPop: WizPopUp = null; // popUp d'affichage du menu burger

  /**
   * affichage du menu burger
   * @param show : true pour afficher (défaut), false pour masquer
   */
  public showBurgerPop(show: boolean = true): void {
    if (PopUpManager.exist(this.burgerPop)) {
      // suppression de l'instance existante
      this.burgerPop.hide();
      return;
    }

    // construction unique de l'instance
    this.burgerPop = new WizPopUp(MenuPopUp, false, false, null, MenuPopUp.width, MenuPopUp.height, null, null, {
      left: '2px',
      top: '32px',
    });

    this.burgerPop.show();
  }

  installPWA() {
    if (!this.deferredPrompt) return;

    this.deferredPrompt.prompt(); // Affiche le dialogue d'installation
    this.deferredPrompt.userChoice.then((choiceResult: any) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('Utilisateur a accepté l’installation');
      } else {
        console.log('Utilisateur a refusé l’installation');
      }
      this.deferredPrompt = null;
      this.showInstallButton = false;
    });
  }

  public feedViewState(e: AlkEvent): void {
    //TODO TODO 
    // si pas code & pas shortCode dans form Fd, utiliser clé de Hash pour le code
  }

  public feedVerbose(e: AlkEvent): void {
    Model.getInstance().logs.push(e.data);
  }

}
